var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivePointer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 38,
    height: 38,
    rx: 19,
    fill: "#DFE2E4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0812 16.1164C25.3266 16.1164 26.3362 15.1068 26.3362 13.8614C26.3362 12.616 25.3266 11.6064 24.0812 11.6064C22.8358 11.6064 21.8262 12.616 21.8262 13.8614C21.8262 15.1068 22.8358 16.1164 24.0812 16.1164Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9254 16.1164C15.1708 16.1164 16.1804 15.1068 16.1804 13.8614C16.1804 12.616 15.1708 11.6064 13.9254 11.6064C12.68 11.6064 11.6704 12.616 11.6704 13.8614C11.6704 15.1068 12.68 16.1164 13.9254 16.1164Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0812 27.3928C25.3266 27.3928 26.3362 26.3832 26.3362 25.1378C26.3362 23.8924 25.3266 22.8828 24.0812 22.8828C22.8358 22.8828 21.8262 23.8924 21.8262 25.1378C21.8262 26.3832 22.8358 27.3928 24.0812 27.3928Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9254 27.3928C15.1708 27.3928 16.1804 26.3832 16.1804 25.1378C16.1804 23.8924 15.1708 22.8828 13.9254 22.8828C12.68 22.8828 11.6704 23.8924 11.6704 25.1378C11.6704 26.3832 12.68 27.3928 13.9254 27.3928Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivePointer);
export default __webpack_public_path__ + "static/media/activePointer.c875fdff97dc8ab7ea5596ad399650fa.svg";
export { ForwardRef as ReactComponent };